import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "@mui/material";
import OnBoardingIModal from "@assets/svg/OnBoardingIModal.svg?react";
import useBreakPoinst from "@hooks/useBreakPoinst";
import { useTranslation } from "react-i18next";
import {
  ModalWrapper,
  ImageContainer,
  ContentBox,
  Title,
  Description,
  ActionContainer,
  StyledButton,
} from "./styles/StartModal";

const StartModal = () => {
  const navigate = useNavigate();
  const { isPhone } = useBreakPoinst();
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const checkModalVisibility = () => {
      const storageKey = "OnboardingJournyStartModal";
      const now = new Date();
      const lastShown = localStorage.getItem(storageKey);

      if (!lastShown) {
        const formattedDate = now.toISOString().split("T")[0];
        localStorage.setItem(storageKey, formattedDate);
        setOpen(true);
        return;
      }

      const lastShownDate = new Date(lastShown);
      const timeDifference = now.getTime() - lastShownDate.getTime();
      const hoursDifference = timeDifference / (1000 * 60 * 60);

      if (hoursDifference >= 25) {
        const formattedDate = now.toISOString().split("T")[0];
        localStorage.setItem(storageKey, formattedDate);
        setOpen(true);
      }
    };

    checkModalVisibility();
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Modal open={open} onClose={handleClose}>
        <ModalWrapper $isPhone={isPhone} $lang={language}>
          <ImageContainer onClick={handleClose}>
            <OnBoardingIModal width={"670px"} height={"350px"} />
          </ImageContainer>

          <ContentBox $isPhone={isPhone}>
            <Title $isPhone={isPhone}>{t("onBoardingJourny.Title")}</Title>
            <Description $isPhone={isPhone}>
              {t("onBoardingJourny.description")}
            </Description>
          </ContentBox>

          <ActionContainer $isPhone={isPhone}>
            <StyledButton
              onClick={() => {
                setOpen(false);
                navigate("/chooseChannel");
              }}
              $TextColor="white"
              $BgColor="#5B3FFF"
              $isPhone={isPhone}
              $width="127px"
            >
              {t("onBoardingJourny.connectAccount")}
            </StyledButton>
            <StyledButton
              onClick={() => {
                setOpen(false);
              }}
              $TextColor="#5B3FFF"
              $isPhone={isPhone}
              $BgColor="white"
              $width="85px"
            >
              {t("onBoardingJourny.skip")}
            </StyledButton>
          </ActionContainer>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default StartModal;
